/**
 * @desc 根据instanceId获取变更详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.changeApproval.getDetailByInstanceId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/changeApproval/getByInstanceId`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
